import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.updateFactoringProfileSuccess"],
  payload => payload
);
